import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import {LoadAuthors, LoadArticleTypes, LoadArchives, IsValid} from '../article.worker'

const getDefaultState = () => {
    return {
        creating: false,
        loadingArchives: false,
        loadingTypes: false,
        title: "",
        doi: "",
        archiveId: "",
        articleTypeId: "",
        keywords: "",
        description: "",
        fullText: "",
        publicationDate: "",
        pageStart: "",
        pageEnd: "",
        errors: {},
        archives: [],
        articleTypes: [],
        flag: {
            type: "",
            text: ""
        }
    }
}

const createArticle = (instance) => {
    instance.setState({
        ...instance.state,
        creating: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/article/article/create",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            title: instance.state.title,
            doi: instance.state.doi,
            pageStart: instance.state.pageStart,
            pageEnd: instance.state.pageEnd,
            archiveId: instance.state.archiveId,
            articleTypeId: instance.state.articleTypeId,
            keywords: instance.state.keywords,
            description: instance.state.description,
            publicationDate: instance.state.publicationDate,
            fullText: instance.state.fullText
        }
    }).then(response => handleCreateArticleResponse(instance, response))
    .catch(error => {
        instance.setState({
            ...instance.state,
            creating: false
        })
        alert(error)
    })
}

const handleCreateArticleResponse = (instance, response) => {
    if(response.status !== 200){
        return
    }
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...getDefaultState(),
                flag: {
                    type: "success",
                    text: "Article Created"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                creating: false,
                flag: {
                    type: "error",
                text: response.data.message
                }
            })
    }
}

const CreateArticleWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => IsValid(instance),
        loadArchives: () => LoadArchives(instance),
        loadArticleTypes: () => LoadArticleTypes(instance),
        loadAuthors: () => LoadAuthors(instance),
        createArticle: () => createArticle(instance)
    }
}

export default CreateArticleWorker